var ContentSectionErrorState = /** @class */ (function () {
    function ContentSectionErrorState() {
    }
    ContentSectionErrorState.prototype.isErrorState = function (control, form) {
        return !!(control && control.invalid && (control.dirty || control.touched));
    };
    return ContentSectionErrorState;
}());
export { ContentSectionErrorState };
